<template>
  <div id="paternity">
    <div class="paternity-new_container input-forms">
      <modal
        ref="transferingLoading"
        template="loading"
        ref-name="transferingLoading"
      >
        <p>Gerando formulário de acesso...</p>
      </modal>
      <modal
        id="paternityForm"
        ref="paternityForm"
        template="neutral"
        ref-name="paternityForm"
        :close-button-enabled="true"
        :icon-enabled="true"
        icon-type="success"
        title="Formulário gerado e salvo automaticamente"
        :warning-text="'Atenção: É necessária a assinatura do proprietário ou  responsável técnico do laboratório'"
        :warning-enabled="true"
        @close="onClosePaternityForm"
      >
        <p>
          Imprima o documento, assine, digitalize e envie para
          <br>
          <span style="color: #7f1a54">acessodna.alvaro@dasa.com.br</span>
        </p>
      </modal>

      <PdfViewer
        :pdf-viewer-status="mostrarPDF"
        :pdf-content="pdfURL"
        @close="mostrarPDF = false"
      />

      <subheader title="Paternidade - Solicitação de acesso" />

      <div class="paternity-new__operator width-responsiveness">
        <md-layout
          md-flex="100"
          class="paternity-steps-container"
        >
          <h4>
            Para acesso aos exames de paternidade é necessário uma validação prévia.
            <br>Preencha o formulário abaixo com os dados do solicitante e clique no botão indicado.
          </h4>
        </md-layout>

        <card-form>
          <div
            slot="form-area"
            class="form-container"
          >
            <span class="required-fields-label">* Preenchimento obrigatório</span>

            <md-layout
              md-flex="100"
              style="padding: 0 12px;"
            >
              <h2 class="title-main">
                Dados do Responsável por laudo restrito do Laboratório
              </h2>
            </md-layout>

            <md-layout
              :md-gutter="24"
              md-flex="100"
            >
              <md-layout md-flex="40">
                <md-input-container
                  id="txtName"
                  :class="{ 'md-input-invalid': errors.has('name') }"
                >
                  <label>Nome completo do colaborador do laboratório *</label>
                  <md-input
                    id="txtName"
                    v-model="operator.name"
                    v-validate="'required'"
                    data-vv-validate-on="none"
                    name="name"
                    maxlength="60"
                    type="text"
                    title
                    placeholder="Nome completo do colaborador do laboratório *"
                    @keydown.enter.native="focusNextField('txtCPF')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="25">
                <v-date-picker
                  v-model="operator.birthDate"
                  v-validate="'check_date_format:DD/MM/YYYY|not_future_date|after_date:31/12/1899'"
                  v-mask="'##/##/####'"
                  :tint-color="'#7f1a54'"
                  :pane-width="290"
                  style="width: 100%"
                  mode="single"
                  data-vv-validate-on="none"
                  title
                  name="birthDate"
                  expanded
                  @keydown.enter.native="focusNextFieldDropdownSexo('operatorGender')"
                >
                  <md-input-container
                    id="operatorBirthDate"
                    slot-scope="{ inputValue, updateValue }"
                    :class="{ 'md-input-invalid': errors.has('birthDate') }"
                  >
                    <label>Data de nascimento *</label>
                    <md-input
                      id="dtNewBirthDate"
                      v-validate="'required'"
                      type="text"
                      :value="inputValue"
                      placeholder="Data de nascimento *"
                      name="birthDate"
                      expanded
                      @change.native="updateValue($event.target.value)"
                    />
                    <span
                      v-if="errors.firstByRule('birthDate', 'required')"
                      class="md-error"
                    >Obrigatório</span>
                    <span
                      v-else-if="errors.firstByRule('birthDate', 'check_date_format')"
                      class="md-error"
                    >Valor inválido</span>
                    <span
                      v-else-if="errors.firstByRule('birthDate', 'not_future_date')"
                      class="md-error"
                    >Data não pode ser maior que a atual</span>
                    <span
                      v-else-if="errors.firstByRule('birthDate', 'after_date')"
                      class="md-error"
                    >Ano deve ser maior que 1899</span>
                  </md-input-container>
                </v-date-picker>
              </md-layout>

              <md-layout md-flex="20">
                <md-input-container
                  id="operatorAge"
                  :class="{ 'md-input-invalid': errors.has('cpf') }"
                >
                  <label>CPF *</label>
                  <md-input
                    id="txtCPF"
                    v-model="operator.cpf"
                    v-validate="'required'"
                    v-mask="'###.###.###-##'"
                    type="text"
                    data-vv-validate-on="none"
                    name="cpf"
                    title
                    placeholder="CPF *"
                    @keydown.enter.native="focusNextField('operatorRG')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="15">
                <md-input-container
                  id="operatorGender"
                  name="sexo"
                  :class="{
                    'md-input-placeholder md-advanced-select': true,
                    'md-has-value': operator.gender,
                    'md-input-invalid': errors.has('sexo')
                  }"
                >
                  <label>Sexo *</label>
                  <advanced-select
                    id="cboNewSex"
                    v-model="operator.gender"
                    v-validate="'required'"
                    :options="genderOptions"
                    placeholder
                    name="sexo"
                    data-vv-validate-on="none"
                    title
                    @enter="focusNextField('operatorMother')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>
            </md-layout>

            <md-layout
              :md-gutter="24"
              md-flex="100"
            >
              <md-layout md-flex="40">
                <md-input-container
                  id="operatorMother"
                  :class="{ 'md-input-invalid': errors.has('mother') }"
                >
                  <label>Nome da Mãe *</label>
                  <md-input
                    id="txtMother"
                    v-model="operator.mother"
                    v-validate="'required'"
                    data-vv-validate-on="none"
                    name="mother"
                    maxlength="60"
                    type="text"
                    title
                    placeholder="Nome da Mãe *"
                    @keydown.enter.native="focusNextField('operatorEmail')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="20">
                <md-input-container
                  id="operatorRG"
                  :class="{ 'md-input-invalid': errors.has('rg') }"
                >
                  <label>RG *</label>
                  <md-input
                    id="txtRG"
                    v-model="operator.rg"
                    v-validate="'required'"
                    v-mask="'##.###.###-#'"
                    type="text"
                    data-vv-validate-on="none"
                    name="rg"
                    title
                    placeholder="RG *"
                    @keydown.enter.native="focusNextField('operatorBirthDate')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="25">
                <md-input-container
                  id="operatorEmail"
                  :class="{ 'md-input-invalid': errors.has('email') }"
                >
                  <label>E-mail *</label>
                  <md-input
                    id="txtEmail"
                    v-model="operator.email"
                    v-validate="'required'"
                    data-vv-validate-on="none"
                    name="email"
                    maxlength="60"
                    type="email"
                    title
                    placeholder="E-mail *"
                    @keydown.enter.native="focusNextField('operatorCelular')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="15">
                <md-input-container
                  id="operatorCelular"
                  :class="{ 'md-input-invalid': errors.has('celular') }"
                >
                  <label>Celular *</label>
                  <md-input
                    id="txtCelular"
                    v-model="operator.celular"
                    v-mask="'(##) #####-####'"
                    v-validate="'required'"
                    type="text"
                    data-vv-validate-on="none"
                    name="celular"
                    title
                    placeholder="Celular *"
                    @keydown.enter.native="focusNextField('txtCodLaboratorio')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>
            </md-layout>

            <div class="box-button">
              <button
                id="btnGeneratePDF"
                class="btn btn-primary paternity-new__operator__submit-button"
                @click="validateBeforeSubmit"
              >
                Gerar formulário
              </button>
            </div>
          </div>
        </card-form>

        <div
          class="footer-info"
          style="margin: 40px 0; color: #000; background: #fff; padding: 20px; border-radius: 8px;"
        >
          <p>
            <strong>Atenção!</strong><br>
            Após gerar o formulário, imprima o documento, assine, digitalize e envie para:
            <a
              href="mailto:acessodna.alvaro@dasa.com.br"
              style="color: #7f1a54;"
            >acessodna.alvaro@dasa.com.br</a>
          </p>

          <br>

          <p><strong>Importante!</strong></p>
          <ul style="list-style-type: decimal; margin-left: 20px;">
            <li>
              <strong>Acesso exclusivo:</strong><br>
              O acesso a laudos restritos é exclusivo para colaboradores autorizados do laboratório. Cada responsável deve
              <em>solicitar seu próprio acesso</em> para garantir a conformidade e segurança no uso do sistema.
            </li>
            <br>
            <li>
              <strong>Proteja suas credenciais:</strong><br>
              Não compartilhe suas informações de login e senha com outras pessoas. A segurança das suas credenciais é
              essencial para proteger seus dados e o sistema.
            </li>
            <br>
            <li>
              <strong>Autenticação em dois fatores (2FA):</strong><br>
              Para ativar e garantir o funcionamento da autenticação em dois fatores, é <strong>obrigatório</strong> fornecer:
            </li>
            <ul>
              <li>Um número de celular válido (incluindo DDD);</li>
              <li>Um endereço de e-mail válido.</li>
            </ul>
          </ul>
          <p>
            Essas informações são fundamentais para a segurança e funcionalidade do sistema.
            Em caso de dúvidas ou necessidade de suporte, entre em contato com a equipe técnica.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import strings from '@/strings'
import CardForm from './PaternityForm'
import { scrollToElement } from '@/utils/window-utils'
import { mask } from 'vue-the-mask'
import generatePDF from '@/api/pdf'
import { formatDate } from '@/utils/date-utils'
import { mapGetters } from 'vuex'
import PdfViewer from '../common/PdfViewer.vue'

export default {
  components: {
    subheader: SubHeader,
    'advanced-select': AdvancedSelect,
    'card-form': CardForm,
    PdfViewer
  },
  directives: {
    mask: mask
  },
  data() {
    return {
      genderOptions: strings.genders,
      operator: {
        name: '',
        cpf: '',
        rg: '',
        birthDate: null,
        gender: '',
        mother: '',
        email: '',
        celular: ''
      },
      mostrarPDF: false,
      pdfURL: '/static/pdfs/FORMULARIO-DE-ACESSO-DNA.pdf'
    }
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    validateBeforeSubmit(evt) {
      this.operator.birthDate = formatDate(this.operator.birthDate, 4)
      // Abort if user pressed enter + shift
      if (evt && evt.keyCode === 13 && evt.shiftKey) {
        return
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.operator.gender = this.operator.gender.label
          this.printAccessForm()
          this.clearPageData()
          return
        } else {
          this.analyticsForValidationErrors()
        }

        if (this.errors.items.length) {
          let elementName = this.errors.items[0].field
          let element = ''

          if (elementName === 'sexo') {
            element = document.querySelector('#cboNewSex .multiselect')
          } else {
            element = document.querySelector('[name="' + elementName + '"]')
          }
          scrollToElement(element)
          element.focus()
        }
      })
    },
    analyticsForValidationErrors() {
      let self = this
      this.errors.all().forEach(function (errorMessage) {
        self.$analytics.pushAnalyticsEvent('error-validation', {
          'msg-error': errorMessage
        })
      })
    },
    clearPageData() {
      this.operator = {
        name: '',
        cpf: '',
        rg: '',
        birthDate: null,
        gender: '',
        mother: '',
        email: '',
        celular: ''
      }
      window.scrollTo(0, 0)
    },
    focusNextField(id) {
      document.getElementById(id).focus()
    },
    focusNextFieldDropdownSexo(id) {
      document.getElementById(id).focus()
      document.getElementById('cboNewSex').firstElementChild.focus()
    },
    printAccessForm() {
      this.$refs.transferingLoading.open()
      generatePDF.sendPaternityInfo(JSON.stringify(this.operator))
        .then(response => {
          this.$refs.transferingLoading.close()
          const blob = new Blob([response.data], { type: 'application/pdf' })
          this.pdfURL = URL.createObjectURL(blob)
          this.$refs.paternityForm.open()
          this.$analytics.pushAnalyticsEvent('ga-event', {
            category: 'Paternidade - Solicitação de Acesso',
            action: 'Gerar formulário de acesso',
            'id-user': this.profile.id,
            'id-lab': this.profile.id_laboratory,
            'name-lab': this.profile.laboratoryName
          })
        })
        .catch(error => {
          this.$refs.transferingLoading.close()
          console.error(error)
        })
    },
    onClosePaternityForm() {
      this.mostrarPDF = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../static/stylesheets/mixins';

  .paternity.modals .md-dialog {
    min-width: 660px;
    min-height: 230px;
    border-radius: 7px;
    max-width: 900px;
    font-family: 'Exo 2' !important;

    &-title {
      padding: 32px 34px 13px;
      font-size: 24px;
      font-weight: 300;
      letter-spacing: -0.3px;
      color: rgba(96, 96, 96, 0.87);
      font-family: 'Exo 2' !important;
    }

    .close-button {
      position: absolute;
      top: 23px;
      right: 38px;
    }
  }

  .paternity-steps-container {
    padding-bottom: 3em;
  }

  .paternity-new_container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 58px);
    font-family: 'Exo 2' !important;

    h3 {
      color: #717171;
      display: inline-block;
      padding-bottom: 15px;
      width: 100%;
      font-family: 'Exo 2' !important;
    }

    ul {
      display: inline-block;
      padding-bottom: 15px;

      > li {
        color: #717171;
      }
    }

    .paternity-card-form__container {
      transition: min-height 600ms, opacity 600ms;
      opacity: 1;
      border-radius: 6px;
      font-family: 'Exo 2' !important;

      .submit-button {
        width: 220px;

        &__icon {
          height: 11px;
          min-height: 11px;
          padding-right: 10px;
          width: 11px;

          svg g {
            fill: #fff;
          }
        }
      }

      &.paternity-card-form--collapsed {
        transition: min-height 600ms, opacity 600ms;
        min-height: 90px;

        &.exam__container {
          .collapsed__list__item__edit-button {
            position: absolute;
            right: 27px;
            margin-top: 3px;

            & > .md-icon:not(.md-icon-delete) {
              position: static;
              margin: 0;
              line-height: 16px;
              color: #c2c2c2;
            }
          }

          .collapsed__list__item__delete-button {
            position: absolute;
            margin-top: 3px;
            right: 0;

            & > .md-icon {
              top: -4px;
            }
          }
        }

        .collapsed-container {
          opacity: 1;
          display: flex;
          animation-name: fadein;
          animation-duration: 700ms;

          .collapsed__item {
            .md-input-container {
              flex: 1;
              flex-direction: column;
              margin: 0 15px 0;
              padding-top: 0;

              &:after {
                height: 0;
              }
            }

            h3 {
              font-size: 12px;
              color: #858585;
              font-weight: normal;
              white-space: nowrap;
            }
            input {
              font-size: 16px;
            }
          }
        }
      }

      .form-container {
        animation-name: fadein;
        animation-duration: 700ms;
        display: flex;
        font-family: 'Exo 2' !important;

        .required-fields-label {
          position: absolute;
          right: 5px;
          top: -30px;
          font-size: 12px;
          color: #a80009;
        }

        .tab-label {
          position: absolute;
          right: 180px;
          top: -30px;
          font-size: 12px;
          color: #000;

          strong {
            font-weight: 700;
          }
        }

        .md-layout {
          .md-input-container {
            margin: 0 0 17px;
          }
        }

        .md-input-container,
        .md-input-container.md-input-focused {
          .md-icon {
            color: #c2c2c2;
          }
        }
      }

      .collapsed-container {
        animation-name: fadeout;
        animation-duration: 700ms;
        display: none;
      }
    }

    .paternity-new__operator {
      margin-top: 150px;
      font-family: 'Exo 2' !important;

      .form-container {
        .md-gutter-24:not(.md-column) {
          margin-right: 0;
          margin-left: 0;
        }
      }

      .collapsed-container {
        .collapsed__list {
          display: flex;

          &__item {
            margin: 0 15px 0;

            &:last-child {
              margin-left: 5px;
            }
          }

          .collapsed__title {
            font-size: 12px;
            color: #858585;
            font-weight: normal;
          }

          .collapsed__text {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 16px;
            color: #303030;
            margin-top: 2px;
            letter-spacing: normal;
          }

          input {
            font-size: 16px;
          }
        }
      }

      @media all and (-ms-high-contrast: none) {
        .md-layout {
          .md-layout {
            display: table;
          }
        }
      }

      .advanced-select__container .multiselect__option--selected,
      .advanced-select__container .multiselect__option--selected.multiselect__option--highlight {
        background: #fff;
        font-weight: bold;
        font-family: 'Exo 2' !important;
      }

      .advanced-select__container .multiselect__option--highlight {
        background: #ddd !important;
      }
    }

    .paternity-new {
      &__exam {
        height: 400px;

        &__save-button {
          width: 182px;

          &__icon {
            margin: 0 7px 0 0;
            width: 16px;
            height: 15px;
            min-height: 15px;
            min-width: 16px;
          }
        }
        &__save-reload-button {
          width: 263px;
          margin-right: 20px;

          &__icon-reload {
            margin: 0 7px 0 0;
            width: 16px;
            height: 15px;
            min-height: 15px;
            min-width: 16px;
          }
        }
      }

      &__operator__title {
        margin: 28px 0 30px;
      }

      &__exam__title {
        margin: 54px 0 31px;
      }

      &__observation-container {
        width: 100%;

        .md-input {
          overflow-y: hidden !important;
          overflow: hidden;
          -ms-overflow-x: hidden;
          -ms-overflow-y: hidden !important;
          max-height: none;
        }
      }

      &__footer {
        margin: 36px 0;
        .endButton {
          flex-wrap: nowrap;
        }
      }
    }

    .advanced-select {
      &__container {
        .multiselect {
          &__single {
            font-family: 'Exo 2' !important;
            width: 100%;
            color: #303030;
            font-size: 16px;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
              margin: 1px 0 0;
            }
          }
        }
      }
    }
  }

  @keyframes fadeout {
    0% {
      opacity: 1;
    }
    99% {
      opacity: 0;
    }
    100% {
      display: none;
    }
  }
  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    //Prevent z-index overlapping in the patient gender combo
    #operatorGender {
      z-index: 3;
    }
  }

  .IE {
    .new-exam {
      .search-results__exams {
        .exam__container {
          .exam-item__details.md-flex-25 {
            min-width: 17%;
            max-width: 18.3%;
          }
        }
      }
    }
    @media only screen and (max-width: 1024px) {
      .new-exam {
        .search-results__exams {
          .paternity-exam {
            .collapsed__item {
              padding: 0;
            }
            .md-flex-35 {
              min-width: 10%;
              .md-theme-default {
                width: 240px;
                margin-right: 0;
              }
            }
          }
          .exam__container {
            .exam-item__details.md-flex-25 {
              min-width: 17%;
              max-width: 21.7%;
            }
          }
        }
      }
      .paternity-new_container
        .paternity-card-form__container.paternity-card-form--collapsed
        .collapsed-container
        .collapsed__item
        p {
        width: 100%;
      }
    }
  }

  .paternity-new_container h4 {
    color: #717171;
    width: 100%;
    font-weight: 400;
    font-family: 'Exo 2' !important;
  }

  #paternityForm {
    .md-dialog {
      &-content {
        overflow: hidden;
      }

      &-title {
        display: flex;
        justify-content: center;
      }

      .standard-modal__title {
        i {
          margin-left: 0;
        }
      }

      p {
        text-align: center;
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 18px;
        font-weight: 400;
        color: #717171;
      }
    }

    .close-button {
      top: 5px !important;
      right: 15px !important;
    }
  }

  .subheader_container .subheader__content h2 {
    font-family: 'Exo 2' !important;
  }

  .box-button {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    .paternity-new__operator__submit-button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      font-size: 13px;
      text-transform: uppercase;
      font-family: 'Exo 2' !important;
      font-weight: 600;
      margin-top: 12px;
    }
  }
</style>
